import React, { useEffect, useState } from "react";
import { fetchMarketMovers,fetchMarketMovers_sparkline } from "../api";
import Plot from "react-plotly.js";
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from "react-sparklines";

const LiveMarketOverview = () => {
  const [indices, setIndices] = useState([]);
  const [loading, setLoading] = useState(true);
 const [sparklineData, setSparklineData] = useState({});
  const [loadingSparklines, setLoadingSparklines] = useState(true);

  const fetchLiveData = async () => {
    try {
      setLoading(true);
      const data = await fetchMarketMovers("indices");
      const stocks = data.stocks;
      setIndices(stocks);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching market data:", error);
      setLoading(false);
    }
  };

  // Fetch Sparkline Data (every 5 minutes)
  const fetchLiveSparklineData = async () => {
    try {
      setLoadingSparklines(true);
      const data = await fetchMarketMovers_sparkline("indices");
      // Example: { symbol1: [{ ts, last_price }, ...], symbol2: [...], ... }
      setSparklineData(data);
      console.log('SPARKLINE',sparklineData)
      setLoadingSparklines(false);
    } catch (error) {
      console.error("Error fetching sparkline data:", error);
      setLoadingSparklines(false);
    }
  };


  useEffect(() => {
    fetchLiveData();
    const intervalId = setInterval(fetchLiveData, 30000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    fetchLiveSparklineData();
    const intervalId = setInterval(fetchLiveSparklineData, 300000);  // 5 minutes
    return () => clearInterval(intervalId);
  }, []);

  // const getColor = (change) => (change > 0 ? "green" : "red");
    const getColor = (change) => {
      if (change > 0) return "green";
      else if (change < 0) return "red";
      else return "blue";  // Zero change
    };

  const styles = {
    marketContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      padding: "16px",
    },
    tile: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      background: "#ffffff",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "16px",
      width: "200px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    },
    indexName: { fontSize: "1.2rem", fontWeight: "bold", color: "#333" },
    dataContainer: { display: "flex", flexDirection: "column", alignItems: "center", margin: "8px 0" },
    currentValue: { fontSize: "1.5rem", fontWeight: "bold", color: "#333" },
    change: { fontSize: "1rem" },
    chart: { width: "100%", height: "50px" },
  };

  return (
    <div style={styles.marketContainer}>
      {indices.map((index) => (
        <div style={styles.tile} key={index.symbol}>
          <h3 style={styles.indexName}>{index.name}</h3>
          <div style={styles.dataContainer}>
            <span style={styles.currentValue}>{index.currentValue}</span>
            <div style={{ ...styles.change, color: getColor(index.change) }}>
              {index.change !== 0 && (
                <>
                  <span>{index.change > 0 ? "+" : ""}{index.change}%</span>
                  <span>({index.pointChange > 0 ? "+" : ""}{index.pointChange.toFixed(2)})</span>
                </>
              )}
            </div>
          </div>

          {/* Intraday Sparkline Chart */}
          {/*{sparklineData[index.name] && (*/}
          {/*  <Plot*/}
          {/*    data={[*/}
          {/*      {*/}
          {/*        x: sparklineData[index.name].map((tick) => new Date(tick.ts * 1000)),*/}
          {/*        y: sparklineData[index.name].map((tick) => tick.last_price),*/}
          {/*        type: "scatter",*/}
          {/*        mode: "lines",*/}
          {/*        line: { color: getColor(index.change) },*/}
          {/*      },*/}
          {/*    ]}*/}
          {/*    layout={{*/}
          {/*      title: "",*/}
          {/*      height: 50,*/}
          {/*      margin: { t: 10, b: 20, l: 30, r: 30 },*/}
          {/*      xaxis: { showgrid: false, showticklabels: false },*/}
          {/*      yaxis: { showgrid: false, showticklabels: false },*/}
          {/*      plot_bgcolor: "transparent",*/}
          {/*      paper_bgcolor: "transparent",*/}
          {/*    }}*/}
          {/*    config={{ displayModeBar: false }}*/}
          {/*    style={styles.chart}*/}
          {/*  />*/}
          {/*)}*/}

          {sparklineData[index.name] && (
            <Sparklines data={sparklineData[index.name].map((tick) => tick.last_price)} svgWidth={100} svgHeight={30}>
              <SparklinesLine color={getColor(index.change)} />
              {/*<SparklinesReferenceLine*/}
              {/*  type="custom"*/}
              {/*  // value={sparklineData[index.name][0].prev_close}*/}
              {/*  value={(index.currentValue - index.pointChange)}*/}
              {/*  style={{ stroke: 'black', strokeDasharray: '2, 2' }}*/}
              {/*/>*/}
            </Sparklines>
          )}
        </div>
      ))}
    </div>
  );
};

export default LiveMarketOverview;

